module.exports = __webpack_public_path__ + "img/Roadshow SMKN 10 Jakarta.f9450bdf.jpeg";